import React from 'react';
import './ui.css';

/**
 * Button variants from the handoff:
 *  - primary     filled #1A1614, white text, 36px (page primary action, modal confirm)
 *  - secondary   outlined on white, 34px (drawer secondary, modal cancel)
 *  - destructive filled #C41E45 (destructive modal confirm)
 *  - danger-text text-only #C41E45 (drawer destructive action)
 *  - ghost       12.5px text-only #7C736D (Clear, Save current view)
 *  - onDark      translucent white, used inside the bulk action bar
 */
const Button = React.forwardRef(function Button(
  {
    variant = 'secondary',
    icon,
    trailingIcon,
    loading = false,
    disabled = false,
    children,
    className = '',
    type = 'button',
    ...rest
  },
  ref
) {
  const isDisabled = disabled || loading;

  return (
    <button
      ref={ref}
      type={type}
      disabled={isDisabled}
      className={`sv-btn sv-btn--${variant} ${className}`}
      {...rest}
    >
      {loading && <span className="sv-btn__spinner" aria-hidden="true" />}
      {!loading && icon && <i className={`bx ${icon} sv-btn__icon`} aria-hidden="true" />}
      {children != null && <span className="sv-btn__label">{children}</span>}
      {trailingIcon && <i className={`bx ${trailingIcon} sv-btn__icon`} aria-hidden="true" />}
    </button>
  );
});

export default Button;
